/**
 *
 * @module purchaseManagerExtrasMap
 *
 */

import Check from 'check-types';
import Logging from './../../logging/entry';
import RetryPolicy from './retryPolicy';

/**
 *
 * @class PurchaseManagerExtrasMap
 * @desc Provides additional configuration information used by the manager.
 *
 */
export default class PurchaseManagerExtrasMap {

    /**
     *
     * @param {RetryPolicy} retryPolicy
     * @param {SDK.Logging.Logger} [logger=Logging]
     *
     */
    constructor(retryPolicy, logger = Logging) {

        const errorMessage = {
            ctor: 'PurchaseManagerExtrasMap(retryPolicy, logger)',
            get retryPolicy() {
                return `${this.ctor} needs RetryPolicy instance`;
            }
        };

        if (Check.not.instanceStrict(retryPolicy, RetryPolicy)) {
            logger.warn('PurchaseManagerExtrasMap', errorMessage.retryPolicy);
        }

        /**
         *
         * @access public
         * @type {RetryPolicy}
         * @desc Gets or sets the retry policy to help drive the retry behavior for service failures.
         *
         */
        this.retryPolicy = retryPolicy;

    }

}



// WEBPACK FOOTER //
// ./src/services/configuration/purchaseManagerExtrasMap.js